import { fetcher } from '../utils'
import { ComponentTagVO } from '@repo/types'
import { ComponentFilterOptionsVO } from '@repo/types/src/types/ComponentFilterOptionsVO'

export default async (): Promise<ComponentFilterOptionsVO> => {
  return fetcher(`/api/user/filter/options`, 'GET', undefined)
}
